const DEFAULT_TIMEOUT_MS = 1500;

/** Runs when the browser has a moment, at the latest after the timeout. Returns how to cancel it. */
export const whenIdle = (run: () => void, timeoutMs = DEFAULT_TIMEOUT_MS): (() => void) => {
  if (typeof window.requestIdleCallback === 'function') {
    const id = window.requestIdleCallback(run, { timeout: timeoutMs });
    return () => window.cancelIdleCallback(id);
  }
  // Safari: no idle callback, but at least not in the same task
  const timer = setTimeout(run, 1);
  return () => clearTimeout(timer);
};
